import { openSelectList } from '@/main/router/routerPath';
import { BaseApi } from '@/main/baseApi';

import { BaseInput } from '#components/dms/common/baseInput';
import DmsInputRemoteSearch from '#components/dms/form/input/InputRemoteSearch.vue';


export function selectName(storeObject: string) {
	return `${storeObject}Select`;
}

export const BaseSelect = BaseInput.extend({
	components: {
		DmsInputRemoteSearch,
	},
	props: {
		filter: Object,
		dataMapper: { type: Function },
		text: { type: [String, Number] },
		mutationName: { type: String },
		actionName: { type: String },
		autofocus: { type: Boolean },
		noLabelAlign: { type: Boolean, default: false },
	},

	data() {
		return {
			textFieldName: 'TEXT',
			searchValue: null as string | null,
			emptyObject: { value: null, text: null },
		};
	},

	computed: {
		valueCmp: {
			get(): string | number | boolean {
				return this.value;
			},
			set(val: string | number | boolean) {
				this.$emit('update:value', val);
			},
		},
		searchValueCmp: {
			get(): string {
				return this.searchValue || String(this.value);
			},
			set(val: string) {
				this.searchValue = val;
			},
		},
	},
	methods: {
		async openGrid() {
			await openSelectList(
				(this as any).storeObject,
				{
					afterRowSelection: this.selected,
					filter: this.filter,
				},
			);
			this.setPageManagerMapper();
		},
		setPageManagerMapper() {
			const { dataMapper, dbToBaseMapper, mutationName, actionName } = this;
			const methodName = mutationName || actionName || dataMapper.name.replace('bound ', '');
			this.$store.commit('pageManager/PAGE_MGR_MAPPER', { dataMapperName: methodName, dbToBaseMapper }, { root: true });
		},
		clearClick() {
			this.searchValue = null;
			this.clear();
			this.$emit('clear');
		},
		dbToBaseMapper(data: any) {
			return { value: data[(this as any).valueFieldName], text: data[this.textFieldName] };
		},
		clear() {
			const { mode } = this;
			const emptyData = { data: this.emptyObject, mode };
			if (this.mutationName) {
				this.$store.commit(this.mutationName, emptyData);
			} else {
				this.dataMapper && this.dataMapper(emptyData);
			}
			this.actionName && this.$store.dispatch(this.actionName, { data: emptyData }, { root: true });
		},
		async selected({ row }: any) {
			const data = this.dbToBaseMapper(row);
			const { mode } = this;
			if (this.mutationName) {
				this.$store.commit(this.mutationName, { data, mode });
			} else {
				this.dataMapper && this.dataMapper({ data });
			}
			this.actionName && await this.$store.dispatch(this.actionName, { data }, { root: true });
		},
		apiSchemaFetch(this: { apiProvider: BaseApi }) {
			return this.apiProvider.tableSchemaSelect();
		},
		apiDataFetch(this: { apiProvider: BaseApi }, filter: object) {
			return this.apiProvider.tableDataSelect(filter);
		},
		onFocusHandler(e: Event) {
			this.$emit('focus', { event: e, vueElement: this });
		},
	},
});
